/* eslint-disable prefer-const */
import { Show } from "solid-js";
import { TranslationField } from "~/components/TranslationField";
import { useFaqWidget } from "../../../providers/context";
import { Group } from "~/components/ui/group";
import { Text } from "~/components/ui/text";
import { Spacer } from "~/components/ui/spacer";
import { ContentFrame } from "../ContentFrame";
import { FaqDownloadButton } from "../Buttons/download";
import { FaqSpeechButton } from "../Buttons/speech";
import { FaqBookmarkButton } from "../Buttons/bookmark";

export function FaqViewerDesktop() {

	const { selected } = useFaqWidget();

	return (
		<div class="flex flex-col flex-1 bg-transparent">
			<Show when={selected()}>
				{(article) => (
					<Group>
						<div>
							<Text class="text-gray-600 mb-1 block">
								<TranslationField key={article().category?.title} />
							</Text>
							<Text class="font-medium block" size="xl">
								<TranslationField key={article().question} />
							</Text>
						</div>
						<Spacer />
						<FaqDownloadButton />
						<FaqSpeechButton />
						<FaqBookmarkButton />
					</Group>
				)}
			</Show>
			<ContentFrame />
		</div>
	);
}